// src/App.tsx
import React from "react";
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import { PageView } from "./PageView";
import { SlugEditor } from './SlugEditor';
import { AuthProvider, useAuth } from './AuthContext';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import { PageTree } from './components/PageTree';
import '@react-page/editor/lib/index.css';
import './App.css';

const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";

const Navigation = ({ togglePageTree }: { togglePageTree: () => void }) => {
  const { user, login, logout, isAdmin, loading } = useAuth();

  if (loading || !user) return null;

  const handleSuccess = (credentialResponse: any) => {
    if (credentialResponse.credential) {
      login(credentialResponse.credential);
    }
  };

  return (
    <nav className="main-nav">
      <div className="nav-logo"></div>
      <div className="nav-links">
        {isAdmin && (
          <button className="admin-btn" onClick={togglePageTree}>Page Tree</button>
        )}
        {user ? (
          <>
            <span>Welcome, {user.first_name || user.username}</span>
            <button className="logout-btn" onClick={logout}>Logout</button>
          </>
        ) : (
          <GoogleLogin
            onSuccess={handleSuccess}
            onError={() => console.log('Login Failed')}
          />
        )}
      </div>
    </nav>
  );
}

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { user, loading } = useAuth();
  if (loading) return <div>Loading...</div>;
  if (!user) return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <p>Access Denied. Please Login as an Admin.</p>
      <Link to="/" style={{ color: '#007bff', fontWeight: 'bold' }}>Return to Homepage</Link>
    </div>
  );
  return <>{children}</>;
}

function App() {
  const [showPageTree, setShowPageTree] = React.useState(false);

  return (
    <GoogleOAuthProvider clientId={CLIENT_ID}>
      <AuthProvider>
        <BrowserRouter>
          <Navigation togglePageTree={() => setShowPageTree(!showPageTree)} />
          {showPageTree && (
            <div className="page-tree-overlay" onClick={() => setShowPageTree(false)}>
              <div className="page-tree-container" onClick={e => e.stopPropagation()}>
                <PageTree onSelect={() => setShowPageTree(false)} />
              </div>
            </div>
          )}
          <Routes>
            <Route path="/" element={<PageView />} />
            <Route path="/:slug" element={<PageView />} />
            {/* Slug-based editor route */}
            <Route path="/editor/:slug" element={<ProtectedRoute><SlugEditor /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </GoogleOAuthProvider>
  );
}
export default App;
